<script setup lang="ts">
import { gaiaNeutral } from '../themes/tokens';

const props = defineProps({
  /**
   * CSS grid tracks (`1fr 1.6fr 1fr`). Set, the strip is a grid of stacked
   * cells (Contract View mock: Signature · Matter · Type) instead of one
   * wrapping line of inline ones.
   */
  columns: {
    type: String,
    default: undefined,
  },
});

const border = gaiaNeutral.borderCard;
const bg = gaiaNeutral.surfaceChild;
const dividerColor = gaiaNeutral.borderDivider;
</script>

<template>
  <!-- Horizontal meta strip from the File Detail mock (Contract · Kind ·
       Signed · Created · Updated) — compose GaiaMetaItem children; dividers
       render between them. Bespoke chrome on the shared tokens. -->
  <div
    v-if="props.columns"
    class="gaia-meta-strip grid"
    :style="{ gridTemplateColumns: props.columns }"
  >
    <slot />
  </div>
  <n-flex v-else align="center" :size="0" class="gaia-meta-strip">
    <slot />
  </n-flex>
</template>

<style scoped>
.gaia-meta-strip {
  border: 1px solid v-bind(border);
  border-radius: 10px;
  background: v-bind(bg);
  padding: 0 4px;
}

.gaia-meta-strip.grid {
  display: grid;
  padding: 0;
}

.gaia-meta-strip :deep(.gaia-meta-item + .gaia-meta-item) {
  border-left: 1px solid v-bind(dividerColor);
}
</style>
